import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // fake login
  const login = (email, password) => {
    const loggedUser = { name: "John Doe", email };
    setUser(loggedUser);
    return true;
  };

  // fake register
  const register = (name, email, password) => {
    const newUser = { name, email };
    setUser(newUser);
    return true;
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
